import { API } from "aws-amplify";
import './init-api';
import { ContactFormModel } from '@model/dist/esm';


const apiName = 'ClientRestApi'
const path = '/contact'

export const postContact = async (contactForm: ContactFormModel, captcha: string) => {

    const init = {
        body: {
            form: contactForm,
            captcha
        }
    }

    return await API.post(apiName, path, init)
}

